module.exports = __webpack_public_path__ + "img/model-y-selection.857ed36a.jpg";